/* Imports */
import React from "react"
import { Flexbox } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"
import GridItem from "../../components/GridItem"

import commonProps from "../../data/common-props"

const FlexboxPage = () => {
    const items = [
        {
            content: (
                <Flexbox
                    direction="column-reverse"
                    gap="l"
                    align="flex-end"
                    justify="flex-end"
                >
                    <GridItem />
                    <GridItem>Longer item</GridItem>
                    <GridItem />
                    <GridItem>Even longer item</GridItem>
                </Flexbox>
            ),
            code: '<Flexbox\n    direction="column-reverse"\n    gap="l"\n    align="flex-end"\n    justify="flex-end"\n>\n    \n</Flexbox>',
        },
    ]

    const propsItems = [
        {
            name: "direction",
            type: "String",
            example: "column",
            possible: '"row" | "row-reverse" | "column" | "column-reverse"',
            default: "row",
        },
        {
            name: "wrap",
            type: "String",
            example: "wrap",
            possible: '"nowrap" | "wrap" | "wrap-reverse"',
            default: "nowrap",
        },
        {
            name: "justify (justify-content)",
            type: "String",
            example: "space-between",
            possible: commonProps.flexJustify,
            default: "flex-start",
        },
        {
            name: "align (align-items)",
            type: "String",
            example: "center",
            possible: commonProps.flexAlign,
            default: "flex-start",
        },
        {
            name: "gap",
            type: "String or Number",
            example: "l",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "columnGap",
            type: "String or Number",
            example: "xl",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "rowGap",
            type: "String or Number",
            example: "s",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "padding",
            type: "String or Number",
            example: "xl",
            possible: `${commonProps.spacers} | any number | any string value`,
        },
        {
            name: "inline",
            type: "Boolean",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default FlexboxPage
